import _Set from "@babel/runtime-corejs3/core-js-stable/set";
const SUPPORTED_HTML_CONTAINER = new _Set(['div', 'form', 'article', 'ul', 'ol', 'li']);
export const isSupportedHTMLContainer = component => SUPPORTED_HTML_CONTAINER.has(component);